<div class="main-box" fxLayout="row">
    <div fxFlex="5.5" class="sub-box left-box-flex" fxLayout="row">
        <img src="assets/entry-point.svg" class="selected-icon">
    </div>
    <div fxFlex="66.15" class="sub-box">
        <div class="grey-heading-container" style="justify-content: flex-start;">
            <img src="assets/back-icon.svg" style="margin-right: 7px; cursor: pointer;"
                routerLink="/admin/banners/list-banner">
            <span class="text">Chat Page Banner</span>
        </div>
        <div style="padding: 10px; padding-top: 0px;">
            <mat-form-field >
              <p class="form-heading-text">Title</p>
                <input matInput type="text" style="position: absolute;width: 90%;" [(ngModel)]="bannnerName" >
                <span *ngIf="bannnerName===''" class="placeholder-text">Enter text</span>
                <div fxLayoutAlign="end center" class="count-text">{{bannnerName.length}}</div>
              </mat-form-field>
            <div class="form-heading-text">Banner Design</div>
            <div class="grey-container" fxLayout="column" style="gap: 10px;">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p class="form-heading-text" style="font-size: 13px;">Image</p>
                    <mat-slide-toggle [checked]="isImageToggle === true ? true : false" color="primary" (change)="onToggleChange($event, 'image')"></mat-slide-toggle>
                </div>
                <div *ngIf="isImageToggle && selectedImageName ===''" class="image-upload">
                    <img src="assets/upload.svg">
                    <div fxLayout="column" style="cursor: pointer;" (click)="triggerImageUploadInput.click()">
                        <span
                            style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">Drag
                            and drop or <span style="color: #386AF6;">Upload </span></span>
                        <span
                            style="color: #696969; font-size: 9px; font-family: Montserrat; font-weight: 400; line-height: 12.60px; word-wrap: break-word">Upload
                            a PNG image less than 1 MB</span>
                    </div>
                    <input #triggerImageUploadInput type="file" accept=".png" (change)="uploadImage($event)"
                        style="display: none;" />
                </div>
                <div *ngIf="selectedImageName !='' && isImageToggle" class="uploaded-media-div">
                    <span class="">{{selectedImageName}}</span>
                    <img src="assets/delete-icon.svg" style="height: 26px; cursor: pointer;"
                        (click)="deleteInputImage()">
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p class="form-heading-text" style="font-size: 13px;">Button</p>
                    <mat-slide-toggle [checked]="isButtonToggle" color="primary" (change)="onToggleChange($event, 'button')"></mat-slide-toggle>
                </div>
                <div *ngIf="isButtonToggle">
                    <mat-form-field style="width: 40%;" [formGroup]="bannerDesignForm" >
                        <input matInput type="text" style="position: absolute;width: 90%;" formControlName="buttonText" maxlength="10"> 
                        <span *ngIf="!bannerDesignForm.controls['buttonText'].value.length" class="placeholder-text">Button text</span>
                        <div fxLayoutAlign="end center" class="count-text">{{bannerDesignForm.controls['buttonText'].value.length}}/10</div>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p class="form-heading-text" style="font-size: 13px;">Timer</p>
                    <mat-slide-toggle [checked]="isTimerToggle" color="primary" (change)="onToggleChange($event, 'timer')"></mat-slide-toggle>
                </div>
                <div *ngIf="isTimerToggle" style="margin-top: 20px; gap: 20px;" fxLayout="row" [formGroup]="bannerDesignForm">
                    <input type="number" min="0" formControlName="timer">
                    <button style="border-radius: 8px;border: 1px #ECECEC solid;background: white;width: 25%;">
                        <mat-select [(value)]="selectedTimeInComponent" class="dropdown-text"
                            style="padding: 10px;">
                            <mat-option value="minutes" class="dropdown-text">Minutes</mat-option>
                            <mat-option value="hours" class="dropdown-text">Hours</mat-option>
                        </mat-select>
                    </button>
                </div>
                <div fxLayout="row" fxLayoutAlign="start" style="gap: 80px;" [formGroup]="bannerDesignForm">
                    <mat-form-field style="width: 40%;">
                        <p class="form-heading-text" style="font-size: 13px;">Small text</p>
                        <input matInput type="text" style="position: absolute;width: 90%;" formControlName="smallText" maxlength="50">
                        <span  *ngIf="!bannerDesignForm.controls['smallText'].value || bannerDesignForm.controls['smallText'].value.length" class="placeholder-text">Enter text</span>
                        <div *ngIf="bannerDesignForm.controls['smallText'].value && bannerDesignForm.controls['smallText'].value.length" fxLayoutAlign="end center" class="count-text">{{bannerDesignForm.controls['smallText'].value.length}}/50</div>
                    </mat-form-field>
                    <mat-form-field style="width: 40%;">
                        <p class="form-heading-text" style="font-size: 13px;">Large text</p>
                        <input matInput type="text" style="position: absolute;width: 90%;" formControlName="largeText" maxlength="50">
                        <span *ngIf="!bannerDesignForm.controls['largeText'].value.length"  class="placeholder-text">Enter text</span>
                        <div fxLayoutAlign="end center" class="count-text">{{bannerDesignForm.controls['largeText'].value.length}}/50</div>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between end">
                <p class="form-heading-text">Schedule Banner</p>
                <mat-form-field style="height: 4rem;">
                    <mat-select [(value)]="selectedShedule" class="dropdown-text dropdown-box">
                        <mat-option value="daily" class="dropdown-text">Daily</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="grey-container" fxLayout="column" style="gap: 10px;">
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <p class="form-heading-text" style="font-size: 13px; width: 12%;">Start Date</p>
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <span>
                            <img src="assets/calender.svg">
                        </span>
                        <input matInput [min]="minEndDate" [matDatepicker]="picker" class="text" [formControl]="startDateForm"
                            placeholder="Select Date" (dateChange)="onStartDateChange($event)">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </button>
                </div>
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <p class="form-heading-text" style="font-size: 13px; width: 12%;">Active From</p>
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <img src="assets/clock.svg">
                        <input type="time" class="text time-style" [(ngModel)]="startTime">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </button>
                </div>
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <p class="form-heading-text" style="font-size: 13px; width: 12%;">Active Until</p>
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <img src="assets/clock.svg">
                        <input type="time" class="time-style text" [(ngModel)]="endTime">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </button>
                </div>
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <p class="form-heading-text" style="font-size: 13px; width: 12%;">End Date</p>
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <span>
                            <img src="assets/calender.svg">
                        </span>
                        <input matInput [min]="minEndDate" [matDatepicker]="picker1" class="text"
                            placeholder="Select Date" (dateChange)="onEndDateChange($event)" [formControl]="endDateForm">
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </button>
                </div>
            </div>
            <div fxLayout="column">
            <mat-form-field>
                <p class="form-heading-text">Redirect to</p>
                <input matInput type="text" style="position: absolute;" [(ngModel)]="redirectUrl">
                <span *ngIf="!redirectUrl" class="placeholder-text">Add deep link URL</span>
                <div fxLayoutAlign="end center" class="count-text">{{redirectUrl.length}}</div>
            </mat-form-field>

            <p class="form-heading-text">Banner Type</p>
            <button style="border-radius: 8px;border: 1px #ECECEC solid;background: white;width: 25%;">
                <mat-select [(value)]="bannerType" class="dropdown-text"
                    style="padding: 10px;">
                    <mat-option *ngFor="let bannerType of allBannerTypes" [value]="bannerType.value" class="dropdown-text">{{bannerType.name}}</mat-option>
                </mat-select>
            </button>
            </div>

        </div>
        <button (click)="prevewBanner()" type="button" class="verify-btn" fxLayoutAlign="center center"style="width: 235px;height: 45px;background: #386AF6; color:#fff">Generate Preview</button>
    </div>
    <div fxFlex="28.35" class="sub-box">
        <div class="grey-heading-container">
            <span class="text">Preview</span>
        </div>

        <div class="prevew-box" *ngIf="isPreviewShow">
            <div fxLayout="row" style="gap: 30px;">
                <img *ngIf="previewObj.isImageToggle" fxFlex="16" [src]="previewObj.imageUrl">
                <div  fxLayout="column">
                    <span class="small-text">{{previewObj.smallText}}</span>
                    <span class="large-text">{{previewObj.largeText}}</span>
                </div>
                <div  fxFlex="25" fxLayout="row" *ngIf="!previewObj.isTimerToggle && previewObj.isButtonToggle">
                    <div style="height: 100%; padding-left: 14px; padding-right: 14px; padding-top: 7px; padding-bottom: 7px; background: linear-gradient(97deg, #386AF6 34%, #8BA9FF 54%, #386AF6 71%); border-radius: 50px; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                        <div style="text-align: center; color: white; font-size: 14px; font-family: Montserrat; font-weight: 500; line-height: 20px; letter-spacing: 0.10px; word-wrap: break-word">{{previewObj.buttonText}}</div>
                     </div>
                </div>
                <div  fxFlex="25" class="timer" fxLayout="row" *ngIf="previewObj.isTimerToggle">
                    <img src="assets/clock.svg">
                    <span style="width: 85px; color: #386AF6; font-size: 14px; font-family: Montserrat; font-weight: 600; line-height: 16.80px; word-wrap: break-word">{{previewObj.timer}} Mins</span>
                </div>
                <mat-icon *ngIf="previewObj.isImageToggle" style="align-self: center;">
                    <span class="material-symbols-outlined">
                        chevron_right
                    </span>
                </mat-icon>
            </div>
        </div>
        <button *ngIf="isPreviewShow" type="button" class="verify-btn" fxLayoutAlign="center center"
        style="height: 45px;background: #386AF6; color:#fff; width: 60%; 
        margin-top: 50px;" (click)="publishBanner()"
        >Publish
      </button>
    </div>
</div>